// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg.app-mui-icon{transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms}", "",{"version":3,"sources":["webpack://./src/styled-base/mui-icon/style.scss"],"names":[],"mappings":"AACA,iBACE,uDAAA","sourcesContent":["$prod: true;\nsvg.app-mui-icon {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
